/* eslint-disable */
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Link } from 'react-router';

import * as mensagemActions from './actions/mensagemActions'
import ConfigD from './util/ConfigD'
import Captcha from './Captcha'
import './css/loginForm.css'
import './css/step.css'
import 'jquery-validation';
import $ from 'jquery';
import Alert from 'react-s-alert';
import './css/consultarProtocolo.css'

class SolicitarAutorizacaoForm extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            erro:'',
            showError:'',
            captchaValue:'',
            captchaUserValue:'',
            captchaValido:false,
            idx:1,

        };
        this.logar = this.logar.bind(this);
        this.refreshCaptcha = this.refreshCaptcha.bind(this);
        this.setCaptchaValue = this.setCaptchaValue.bind(this);
        this.setCaptchaUserValue = this.setCaptchaUserValue.bind(this);
        this.captchaValido = this.captchaValido.bind(this);

    }

    refreshCaptcha(){
        var i = this.state.idx+1;
        this.setState({idx:i});
    }

    captchaValido(){
        
        if(this.state.captchaValue !== '' && this.state.captchaUserValue !== ''){
            if (this.state.captchaValue.toLowerCase() === this.state.captchaUserValue.toLowerCase()) {
                return true;
            }
        }
        else{
            return false;
        }
    }

    setCaptchaValue(text){
        
        this.setState({
            captchaValue: text
        })
    }

    setCaptchaUserValue(val) {
        this.setState({
            captchaUserValue: val
        })
    }

    logar(event){
        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        if(!this.captchaValido()){
            this.setState({showError:true});
            return false;
        }
        else{
            this.setState({showError:false});
        }

        if ($('#consultar-form').valid()) {
           //console.log('validou')
            var protocoloLogin = $('#protocoloLogin').val();
            var senha = $('#senhaLogin').val();

            var data = {
                protocolo: protocoloLogin,
                senha: senha
            }
           //console.log('data - ', data);
            this.props.actions.SolicitarAutorizacaoPorProtocoloSenha(data).catch(error => {
                
                if(error===null){
                    this.setState({erro: 'Protocolo e/ou senha inválido'})
                    $('.alert-danger', $('#consultar-form')).show();
                    this.refreshCaptcha();
                    this.setCaptchaUserValue('');
                }else{
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-left',
                        effect: 'slide',
                        offset: 172,
                        timeout: 10000
                    });
                    
                    this.refreshCaptcha();
                    this.setCaptchaValue('');

                }
            });;

        }


    }

    componentDidMount() {
        
        //this.props.actionCliente.validarCliente(null);
        $('.alert-danger', $('#consultar-form')).hide();
        $('#consultar-form').validate({
            errorElement: 'span',
            errorClass: 'help-block',
            focusInvalid: false,
            rules: {
                protocoloLogin: {
                    required: true
                },
                senhaLogin: {
                    required: true
                }
            },

            messages: {
                protocoloLogin: {
                    required: "Protocolo necessário."
                },
                senhaLogin: {
                    required: "Senha necessária."
                }
            },

            invalidHandler: function (event, validator) {
                //$('.alert-danger', $('#consultar-form')).show();
            },

            highlight: function (element) {
                $(element)
                    .closest('.form-group').addClass('has-error');
            },

            success: function (label) {
                label.closest('.form-group').removeClass('has-error');
                label.remove();
            },

            errorPlacement: function (error, element) {
                error.insertAfter(element.closest('.input-icon'));
            }
        });

    }
    
    componentWillReceiveProps(nextProps) {
        
        if (!$.isEmptyObject(nextProps.mensagem) && this.props.mensagem !== nextProps.mensagem) {
            //console.log('mensagem consultada', nextProps.mensagem)
            Alert.success(nextProps.mensagem.dado, {
                position: 'top-left',
                effect: 'slide',
                offset: 172,
                timeout: 10000
            });
            $('#protocoloLogin').val('');
            $('#senhaLogin').val('');
            
            this.refreshCaptcha();
            this.setCaptchaValue('');


        }
    }

    render() {
        //console.log('servicos', this.props.servicos);
        // if($.isEmptyObject(this.props.servicos)){
        //   return <div/>
        // }
        //console.log('this.props.servicoCalculado ' , this.state.servicoSelecionado)

    return (

        <div>
            <form method="post" id='consultar-form' >
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <h3 className="title">Informe os dados para solicitar que a autenticação seja enviada:</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">

                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="alert alert-danger display-hide">
                                    <button className="close" data-close="alert"></button>
                                    <span tabIndex="0"> {this.state.erro} </span>
                                </div>
                            
                                <div className="form-group">
                                    <div className="input-icon">
                                        <label><b>Protocolo:</b></label>
                                        <input type="text" className="form-control" placeholder="Entre com o protocolo" name="protocoloLogin" id='protocoloLogin' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <div className="input-icon">
                                        <label><b>Senha:</b></label>
                                        <input type="password" className="form-control" placeholder="Senha" name="senhaLogin" id='senhaLogin' />
                                        <Link to={ConfigD.getServerBase() + '/recuperarProtocolo'} className='linkRecuperarProtocolo'>clique aqui para recuperar protocolo e senha</Link>
                                    </div>
                                </div>
                                <Captcha idx={this.state.idx} refreshCaptcha={this.refreshCaptcha} setCaptchaValue={this.setCaptchaValue} setCaptchaUserValue={this.setCaptchaUserValue}  showError={this.state.showError} />
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <button type="submit" onClick={this.logar}>Enviar autenticação</button>
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    );
  }
}

SolicitarAutorizacaoForm.protoType = {
    //actionCliente: PropTypes.object.isRequired
}
SolicitarAutorizacaoForm.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    
    return {
        mensagem: state.mensagem,
        urlNavegacao: state.urlNavegacao
    };
}

function mapDispatchToProps(dispatch){
   return {
        
       actions: bindActionCreators(mensagemActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitarAutorizacaoForm);



/** WEBPACK FOOTER **
 ** ./src/components/SolicitarAutorizacaoForm.js
 **/